import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const discountApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addDiscount: builder.mutation<CommonResponseType, any>({
      query: (body) => ({
        url: END_POINTS.discount,
        method: "POST",
        body,
      }),
    }),
    getDiscounts: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
        type:string;
      }
    >({
      query: ({ from, size, search,type }) => ({
        url:
          `${END_POINTS.discount}?from=${from}&size=${size}&type=${type}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getDiscountDetail: builder.query<
      CommonResponseType & {
        data: any;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.discount}/${id}`,
        method: "GET",
      }),
    }),
    updateDiscount: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.discount}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteDiscount: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.discount}/${id}`,
        method: "DELETE",
      }),
    }),
    discountExport: builder.query<
      CommonResponseType & {
        data: any;
      },
      {}
    >({
      query: () => ({
        url: `${END_POINTS.exportDiscount}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddDiscountMutation,
  useLazyGetDiscountsQuery,
  useLazyGetDiscountDetailQuery,
  useUpdateDiscountMutation,
  useDeleteDiscountMutation,
  useLazyDiscountExportQuery,
} = discountApi;
